import { render } from "./KnowProduct.vue?vue&type=template&id=6b6acf89"
import script from "./KnowProduct.vue?vue&type=script&lang=js"
export * from "./KnowProduct.vue?vue&type=script&lang=js"

import "./KnowProduct.vue?vue&type=style&index=0&id=6b6acf89&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__